export function csrfHeaders(): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-CSRF-Token':
      document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
  }
}
